import { Fragment } from "react";
import { Card, CardBody, Col } from "reactstrap";
import { SOCIAL_USER_CARD_DATA } from "../../../Data/SocialApp";
import { H5, Image, LI, SVG, UL } from "../../../AbstractElements";
import { dynamicImage } from "../../../Service/DynamicImage";
import { Followers, Following, Href, Posts } from "../../../Constant";
import SocialMediaIcons from "../Common/SocialMediaIcons";

const AllCards = () => {
  return (
    <Fragment>
      {SOCIAL_USER_CARD_DATA.map((item) => (
        <Col sm="6" xxl="3" md="4" xl="4" className="col-ed-4 box-col-4" key={item.id}>
          <Card className="social-profile">
            <CardBody>
              <div className="social-img-wrap">
                <div className="social-img">
                  <Image className="img-fluid" src={dynamicImage(`${item.avatar}`)} alt="user" />
                </div>
                <div className="edit-icon">
                  <SVG iconId="profile-check" />
                </div>
              </div>
              <div className="social-details">
                <H5 className="mb-1"><a href={Href}>{item.name}</a></H5>
                <span className="f-light">{item.email}</span>
                <SocialMediaIcons />
                <UL className="social-follow simple-list d-flex flex-row justify-content-center">
                  <LI>
                    <H5 className="mb-0">{item.totalPost}</H5>
                    <span className="f-light">{Posts}</span>
                  </LI>
                  <LI>
                    <H5 className="mb-0">{item.follower}</H5>
                    <span className="f-light">{Followers}</span>
                  </LI>
                  <LI>
                    <H5 className="mb-0">{item.following}</H5>
                    <span className="f-light">{Following}</span>
                  </LI>
                </UL>
              </div>
            </CardBody>
          </Card>
        </Col>
      ))}
    </Fragment>
  );
};
export default AllCards;
